// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallbackLogItem_root__kXjuK {
  display: flex;
  background-color: var(--color-bg-content-callback);
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  cursor: pointer;
  margin-top: 20px;
}

.CallbackLogItem_icon_container__Dc9W0 {
  background-color: var(--color-theme-red);
  width: 55px;
  text-align: center;
  padding-top: 12px;
  border-radius: 10px;
}

.CallbackLogItem_left_container__FAclt {
  flex: 1 1;
  min-width: 265px;
}

.CallbackLogItem_title_icon__nKCXv {
  color: var(--color-font-10);
}

.CallbackLogItem_title_icon__nKCXv svg {
  height: 28px;
  width: 25px;
}

.CallbackLogItem_title_container__pSKo6 {
  display: flex;
}

.CallbackLogItem_title_text__wlPSw {
  font-size: 18px;
  font-weight: bold;
  padding-left: 15px;
  line-height: 33px;
}

.CallbackLogItem_date__dRNZT {
  font-size: 12px;
  padding-left: 15px;
}

.CallbackLogItem_center_container__T-wgn {
  flex: 2 1;
  min-width: 250px;
}

.CallbackLogItem_center_primary__kdvGR {
  font-size: 20px;
  line-height: 20px;
  margin-bottom: 6px;
}

.CallbackLogItem_center_secondary__QUIVR {
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.5px;
}

.CallbackLogItem_center_secondary__QUIVR {
  margin-top: 3px;
  font-size: 12px;
  letter-spacing: 0.5px;
}

.CallbackLogItem_email__KcZGk {
  font-size: 12px;
  margin-top: 4px;
}

.CallbackLogItem_state__rwADy {
  padding-left: 37px;
  margin-top: 26px;
  font-size: 15px;
}

.CallbackLogItem_right_container__55tH9 {
  flex: 3 1;
  max-width: 360px;
  text-align: center;
  padding-top: 15px;
}

.CallbackLogItem_right_container_disabled__KdzW0 {
  flex: 3 1;
  max-width: 360px;
  text-align: center;
  padding-top: 15px;
}

.CallbackLogItem_right_container_disabled__KdzW0 svg {
  color: var(--color-theme-silver);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/CallbackLogItem/CallbackLogItem.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kDAAkD;EAClD,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".root {\n  display: flex;\n  background-color: var(--color-bg-content-callback);\n  padding: 10px;\n  border-radius: 5px;\n  margin-bottom: 15px;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\n.icon_container {\n  background-color: var(--color-theme-red);\n  width: 55px;\n  text-align: center;\n  padding-top: 12px;\n  border-radius: 10px;\n}\n\n.left_container {\n  flex: 1;\n  min-width: 265px;\n}\n\n.title_icon {\n  color: var(--color-font-10);\n}\n\n.title_icon svg {\n  height: 28px;\n  width: 25px;\n}\n\n.title_container {\n  display: flex;\n}\n\n.title_text {\n  font-size: 18px;\n  font-weight: bold;\n  padding-left: 15px;\n  line-height: 33px;\n}\n\n.date {\n  font-size: 12px;\n  padding-left: 15px;\n}\n\n.center_container {\n  flex: 2;\n  min-width: 250px;\n}\n\n.center_primary {\n  font-size: 20px;\n  line-height: 20px;\n  margin-bottom: 6px;\n}\n\n.center_secondary {\n  font-size: 12px;\n  line-height: 20px;\n  letter-spacing: 0.5px;\n}\n\n.center_secondary {\n  margin-top: 3px;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n}\n\n.email {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.state {\n  padding-left: 37px;\n  margin-top: 26px;\n  font-size: 15px;\n}\n\n.right_container {\n  flex: 3;\n  max-width: 360px;\n  text-align: center;\n  padding-top: 15px;\n}\n\n.right_container_disabled {\n  flex: 3;\n  max-width: 360px;\n  text-align: center;\n  padding-top: 15px;\n}\n\n.right_container_disabled svg {\n  color: var(--color-theme-silver);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CallbackLogItem_root__kXjuK`,
	"icon_container": `CallbackLogItem_icon_container__Dc9W0`,
	"left_container": `CallbackLogItem_left_container__FAclt`,
	"title_icon": `CallbackLogItem_title_icon__nKCXv`,
	"title_container": `CallbackLogItem_title_container__pSKo6`,
	"title_text": `CallbackLogItem_title_text__wlPSw`,
	"date": `CallbackLogItem_date__dRNZT`,
	"center_container": `CallbackLogItem_center_container__T-wgn`,
	"center_primary": `CallbackLogItem_center_primary__kdvGR`,
	"center_secondary": `CallbackLogItem_center_secondary__QUIVR`,
	"email": `CallbackLogItem_email__KcZGk`,
	"state": `CallbackLogItem_state__rwADy`,
	"right_container": `CallbackLogItem_right_container__55tH9`,
	"right_container_disabled": `CallbackLogItem_right_container_disabled__KdzW0`
};
export default ___CSS_LOADER_EXPORT___;
